<div class="step-container">
  <div class="step-header">
    <div class="step-header-icon"><i class="fas fa-id-card" aria-hidden="true"></i></div>
    <h2>Recuperar clave Virtual</h2>
    <p>Para tu seguridad, confirmaremos tu identidad antes de actualizar tu clave de acceso.</p>
  </div>

  <form [formGroup]="form" (ngSubmit)="ngSubmit()" novalidate>
    <label class="label-document" id="reset-tipo-label">Tipo de documento de identidad *</label>
    <div class="auth-input-wrap auth-input-wrap--select" [class.is-invalid]="hasError('tipo')">
      <app-custom-select
        formControlName="tipo"
        inputId="reset-tipo"
        ariaLabelledby="reset-tipo-label"
        appearance="auth"
        [options]="tiposDocumentoOptions"
        placeholder="Selecciona tipo"
        placeholderValue="0"
        [invalid]="hasError('tipo')">
      </app-custom-select>
    </div>
    <div class="invalid-feedback d-block" *ngIf="hasError('tipo')">{{ getErrorMessage('tipo') }}</div>

    <label class="label-document">Número de documento *</label>
    <div class="auth-input-wrap" [class.is-invalid]="hasError('numero')"
         [class.auth-input-wrap-nit]="esNIT && digitoVerificacion !== ''">
      <input type="text" formControlName="numero" class="auth-input"
             [placeholder]="placeholderNumero"
             [maxlength]="maxLengthNumero"
             [attr.inputmode]="soloNumeros ? 'numeric' : 'text'"
             (input)="onNumeroInput($event)">
      <span class="nit-digito-verificacion" *ngIf="esNIT && digitoVerificacion !== ''">
        <span class="nit-digito-label">Dígito de verificación:</span>
        <strong>{{ digitoVerificacion }}</strong>
      </span>
    </div>
    <div class="invalid-feedback d-block" *ngIf="hasError('numero')">{{ getErrorMessage('numero') }}</div>

    <div class="button-container">
      <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Continuar a enviar código</button>
    </div>
  </form>
</div>
